/**
 * Join Raid HTTP Service
 *
 * Calls the join-raid endpoint to join an existing raid lobby via invite code.
 */

import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { JoinRaidInput, JoinRaidOutput } from "types/web-app";

/**
 * Join an existing raid lobby using an invite code
 */
export const joinRaid = async (
  accessToken: string,
  input: JoinRaidInput,
): Promise<ServiceResponse<JoinRaidOutput>> => {
  try {
    const response = await fetchWithAuth("/raid/join", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });

    return (await response.json()) as ServiceResponse<JoinRaidOutput>;
  } catch (error) {
    console.error("Error joining raid:", error);
    throw error;
  }
};

